var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.connected)?_c('div',{attrs:{"id":"userView"}},[_c('User')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }